module.exports = __webpack_public_path__ + "img/new-years.10f81f30.jpg";